module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overall-section",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "margin-bottom": "50px",
      "border-color": "#212121"
    },
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Overall")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "icon": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.openColSettingsModal
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('i', {
    staticClass: "fas fa-cog fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Settings"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "overall-content"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "40px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n                                Total Deliverables\n                            ")]), _vm._v(" "), (_vm.displayFields('totalContents')) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "28px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.minContent)) + " to " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.maxContent)) + " Contents\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.displayFields('totalOutreach')) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "28px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignKPI.outreach)) + " Audience Size\n                            ")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                    Achieved\n                                ")])])], 1)], 1), _vm._v(" "), (_vm.displayFields('contents')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.contents)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Contents\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('outreachImpressions')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.outreachImpressions)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Audience Size + Impressions\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('outreach')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.outreach)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Audience Size\n                            ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('interactions')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("thousandSeprator")(_vm.summary.engagement)) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_vm._v("\n                                Interactions\n                            ")])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 pt-2",
    staticStyle: {
      "border-top": "1px solid #212121"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.displayFields('postEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.postEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Post Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('reelEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.reelEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Reel Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('tiktokEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.tiktokEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        TikTok Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('youtubeEngRate')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.youtubeEngRate) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Youtube Engagement Rate by Interactions\n                                    ")])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 pt-2",
    staticStyle: {
      "border-top": "1px solid #212121"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [(_vm.displayFields('postEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.postEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Post Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('reelEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.reelEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Reel Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('tiktokEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.tiktokEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        TikTok Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.displayFields('youtubeEngRateView')) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "center"
    }
  }, [_c('v-card', {
    staticClass: "mx-left",
    attrs: {
      "max-width": "344",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#3F3FFF",
      "font-size": "48px",
      "width": "100%",
      "line-height": "50px"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.youtubeEngRateView) + " %\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "engRate-text"
  }, [_vm._v("\n                                        Youtube Engagement Rate by Views\n                                    ")])])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.displayFields('industryBenchmark')) ? _c('v-row', {
    attrs: {
      "align": "left",
      "justify": "left"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "color": "#3F3FFF",
      "font-size": "30px"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._v("\n                                            Industry Benchmark for \n                                        ")]), _vm._v(" "), _c('div', [(_vm.editBenchmark) ? _c('span', {
    staticClass: "benchmark-fields"
  }, [_c('v-text-field', {
    staticClass: "edit-box",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaignKPI.benchmarkTitle),
      callback: function($$v) {
        _vm.$set(_vm.campaignKPI, "benchmarkTitle", $$v)
      },
      expression: "campaignKPI.benchmarkTitle"
    }
  })], 1) : _c('span', {
    staticClass: "benchmark-fields"
  }, [_vm._v(_vm._s(_vm.campaignKPI.benchmarkTitle))])]), _vm._v(" "), _c('div', [_vm._v(" : ")]), _vm._v(" "), _c('div', [(_vm.editBenchmark) ? _c('span', {
    staticClass: "benchmark-fields"
  }, [_c('v-text-field', {
    staticClass: "edit-box",
    attrs: {
      "solo": ""
    },
    model: {
      value: (_vm.campaignKPI.benchmarkValue),
      callback: function($$v) {
        _vm.$set(_vm.campaignKPI, "benchmarkValue", $$v)
      },
      expression: "campaignKPI.benchmarkValue"
    }
  })], 1) : _c('span', {
    staticClass: "benchmark-fields"
  }, [_vm._v(_vm._s(_vm.campaignKPI.benchmarkValue))])]), _vm._v(" "), _c('div', {
    staticClass: "benchmark-edit"
  }, [(_vm.editBenchmark && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "success",
      "dark": ""
    },
    on: {
      "click": _vm.saveBenchmark
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-done")]), _vm._v(" Save\n                                            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.editBenchmark && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "color": "warning",
      "small": "",
      "dark": ""
    },
    on: {
      "click": _vm.editBenchmarkAction
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "title": "Edit Campaign Summary"
    }
  }, [_vm._v("edit")])], 1) : _vm._e()], 1)])], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider')], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Overall",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updatePerformanceAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1794b2ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/performance.vue
// module id = 2014
// module chunks = 0